import { ReactElement } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import Close from '@monofront/design-system/visuals/Icons/Old/Close';
import Logo from '@monofront/design-system/components/Logo';
import { useAuthentication } from '@context/businessContainer';
import useI18n from '@hooks/i18n/useI18n';

interface ILayoutModalProps {
  children?: ReactElement<any>;
}

const LayoutModal: React.FC<ILayoutModalProps> = ({ children }) => {
  const tGlobal = useTranslations('Global');
  const { isAuthenticated } = useAuthentication();
  const { channel } = useI18n();
  const closeRedirection =
    typeof children?.props === 'object' &&
    children?.props != null &&
    'closeRedirection' in children.props &&
    typeof children.props.closeRedirection === 'string'
      ? children?.props.closeRedirection
      : isAuthenticated
      ? '/home'
      : '/';

  return (
    <>
      <header className="main-header">
        <div className="logo-wrapper">
          <Link href={isAuthenticated ? '/home' : '/'} legacyBehavior>
            <a data-testid="LayoutModal-go-to-home">
              <Logo
                UNSAFE_className="confirmation-logo"
                channel={channel}
                variant="LogoWithBackground"
                role="img"
                aria-label={tGlobal('companyName')}
              />
            </a>
          </Link>
        </div>
        <div className="close">
          <Link href={closeRedirection} legacyBehavior>
            <a data-testid="LayoutModal-close">
              <Close width={14} height={14} aria-hidden />
            </a>
          </Link>
        </div>
      </header>
      <main>{children}</main>
      <style jsx>{`
        header.main-header {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: var(--clr-primary-5);
        }

        .logo-wrapper {
          text-align: center;
          margin: var(--space-5) auto;
        }

        .logo-wrapper a {
          display: block;
        }

        .close {
          position: absolute;
          top: var(--space-6);
          right: var(--space-6);
        }

        .close a {
          padding: var(--space-2);
        }

        @media (max-width: 800px) {
          header.main-header {
            background: var(--white);
            min-height: 60px;
          }

          .logo-wrapper {
            margin: var(--space-2) auto 0;
          }

          .logo-wrapper :global(.confirmation-logo) {
            width: 130px;
          }
        }

        @media (min-width: 801px) {
          :global(body) {
            background: var(--clr-primary-5);
          }
        }
      `}</style>
    </>
  );
};

export default LayoutModal;
